var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2331 1.5293H6.11654C5.71099 1.5293 5.32205 1.6904 5.03528 1.97717C4.74851 2.26394 4.5874 2.65288 4.5874 3.05843V15.2915C4.5874 15.6971 4.74851 16.086 5.03528 16.3728C5.32205 16.6596 5.71099 16.8207 6.11654 16.8207H12.2331C12.6386 16.8207 13.0276 16.6596 13.3144 16.3728C13.6011 16.086 13.7622 15.6971 13.7622 15.2915V3.05843C13.7622 2.65288 13.6011 2.26394 13.3144 1.97717C13.0276 1.6904 12.6386 1.5293 12.2331 1.5293ZM9.93938 16.0561H8.41025V15.2915H9.93938V16.0561ZM12.2331 14.527H6.11654V3.823H12.2331V14.527Z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.aefdc0d70a3caa6e731faae21b0943ab.svg";
export { ForwardRef as ReactComponent };